import React from "react";
import { Card } from "react-bootstrap";
import ReCaptchaV2 from "react-google-recaptcha";
import { config } from "../../config";

interface RegisterStepValidationPersonProps {
    firstName: string;
    setFirstName: (val: string) => void;
    lastName: string;
    setLastName: (val: string) => void;
    dateOfBirth: string;
    setDateOfBirth: (val: string) => void;
    policyNumber: string;
    setPolicyNumber: (val: string) => void;
    lastPremium: string;
    handleLastPremium: (e: React.ChangeEvent<HTMLInputElement>) => void;
    registrationError: string;
    showLoginButton: boolean;
    isProcessing: boolean;
    requireReCaptchaV2: boolean;
    reCaptchaRefStep1: React.RefObject<any>;
    firstNameRef: React.RefObject<HTMLInputElement>;
    lastNameRef: React.RefObject<HTMLInputElement>;
    dateOfBirthRef: React.RefObject<HTMLInputElement>;
    policyNumberRef: React.RefObject<HTMLInputElement>;
    onLoginClick: () => void;
    handleCaptchaStep1: (e: React.FormEvent<HTMLInputElement>) => void;
}

const RegisterStepValidation: React.FC<RegisterStepValidationPersonProps> = ({
    firstName,
    setFirstName,
    lastName,
    setLastName,
    dateOfBirth,
    setDateOfBirth,
    policyNumber,
    setPolicyNumber,
    lastPremium,
    handleLastPremium,
    registrationError,
    showLoginButton,
    isProcessing,
    requireReCaptchaV2,
    reCaptchaRefStep1,
    firstNameRef,
    lastNameRef,
    dateOfBirthRef,
    policyNumberRef,
    onLoginClick,
    handleCaptchaStep1
}) => {
    return (
        <>
            <main
                id="register-form"
                className="d-flex flex-column min-vh-100 justify-content-center align-items-center"
            >
                <section aria-labelledby="register-form-section">
                    <Card
                        body
                        style={{
                            borderStyle: "none",
                            boxShadow: "0 0 10px 0 rgba(100, 100, 100, 0.26)"
                        }}
                    >
                        <form className="add-form">
                            <div>
                                <input id="hdnInputFocus" type="hidden" autoFocus />
                                <h1 className="custom-h1">Registration</h1>
                                {registrationError && registrationError.length > 0 ? (
                                    <>
                                        {showLoginButton ? (
                                            <>
                                                <label aria-live="assertive" role="alert">
                                                    {registrationError}
                                                </label>
                                                &nbsp;
                                                <a href="#" onClick={onLoginClick}>
                                                    Log-in Here.
                                                </a>
                                                <br />
                                                <br />
                                            </>
                                        ) : (
                                            <>
                                                <label
                                                    className="text-danger"
                                                    aria-live="assertive"
                                                    role="alert"
                                                >
                                                    {registrationError}
                                                    <br />
                                                    <br />
                                                </label>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <label>
                                        Please enter the following to help us verify that
                                        it&apos;s you:
                                        <br />
                                        <br />
                                    </label>
                                )}
                            </div>
                            <div>
                                <label>
                                    Owner First Name as it appears on your policy (Required *)
                                </label>
                                <input
                                    id="firstName"
                                    type="text"
                                    className="form-control skip-to"
                                    placeholder=""
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    aria-required={true}
                                    aria-label="Owner First Name"
                                    autoFocus
                                    ref={firstNameRef}
                                ></input>
                            </div>
                            <div>
                                <label>
                                    Owner Last Name as it appears on your policy (Required *)
                                </label>
                                <input
                                    id="lastName"
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    aria-required={true}
                                    aria-label="Owner Last Name"
                                    ref={lastNameRef}
                                ></input>
                            </div>
                            <div>
                                <label>Insured Date of Birth (Required *)</label>
                                <input
                                    id="dateOfBirth"
                                    type="date"
                                    className="form-control"
                                    placeholder="mm/dd/yyyy"
                                    min="1922-01-01"
                                    max="2022-12-31"
                                    value={dateOfBirth}
                                    onChange={(e) => setDateOfBirth(e.target.value)}
                                    aria-required={true}
                                    aria-label="Insured Date of Birth"
                                    ref={dateOfBirthRef}
                                ></input>
                            </div>
                            <div>
                                <span>&nbsp;</span>
                            </div>
                            <div>
                                <label>Policy Number</label>
                                <input
                                    id="policyNumber"
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={policyNumber}
                                    onChange={(e) => setPolicyNumber(e.target.value.trim())}
                                    aria-label="Policy Number"
                                    ref={policyNumberRef}
                                ></input>
                            </div>
                            <div style={{ paddingBottom: "10px", paddingLeft: "5px" }}>
                                <span style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                    OR
                                </span>
                            </div>
                            <div>
                                <label>Last Payment Amount</label>
                            </div>
                            <div>
                                $&nbsp;
                                <input
                                    id="lastPremium"
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    value={lastPremium}
                                    onChange={handleLastPremium}
                                    style={{ display: "inline", width: "95%" }}
                                    aria-label="Last Premium Amount"
                                ></input>
                            </div>
                            {isProcessing ? (
                                <label>Processing...</label>
                            ) : (
                                <div style={{ display: "block" }}>
                                    {/* TODO: Need to replace button with spinner so user can't do multiple submits */}
                                    <input
                                        type="button"
                                        value="Next"
                                        className="btnRounded btn-block"
                                        onClick={handleCaptchaStep1}
                                    ></input>
                                    {requireReCaptchaV2 ? (
                                        <ReCaptchaV2
                                            id="recaptcha"
                                            sitekey={config.app.recaptchav2Key}
                                            ref={reCaptchaRefStep1}
                                            aria-required={true}
                                            aria-label="Recaptcha"
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            )}
                        </form>
                    </Card>
                </section>
            </main>
        </>
    );
};

export default RegisterStepValidation;
